import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable()
export class HomeService {

  constructor(private httpClientService: HttpClientService ) { }

  getNewsList(email) {
    return this.httpClientService.getMethod({
      url: 'news/getList',
      data: {
        name: email
      }
    })
  }

  putElectVote(voteId,sessionId){
    return this.httpClientService.postMethod({
      url: `/web/elect/vote`,
      data: {
        candidateId: voteId,
        sessionId: sessionId
      }
    })
  }



  getElectVoteDetail(){
    return this.httpClientService.getMethod({
      url: '/web/elect/detail',
    })
  }

  getCandidateDeatil(candidateId){
    return this.httpClientService.getMethod({
      url: '/web/elect/candidate/detail',
      data: {
        candidateId: candidateId
      }
    })
  }

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/home.service.ts